import base from '@/__vue2stone/service/api/v1/__base';
import S_Processor from '@/service/app/processor';

export default {
  async index({ params }) {
    return base.index({
      preUrl: S_Processor.getFactoryPreUrl(),
      modelName: 'act_type',
      params: params,
    });
  },
};
